<template>
  <v-alert
    color="green lighten-2"
    dense
    outlined
    type="success"
    max-width="540"
    style="margin: 5px auto"
  >
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  name: 'ErrorMessage'
}
</script>

<style scoped>

</style>
